import React, { useState } from 'react'
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline'
import './index.scss'
import { useTranslation } from 'react-i18next'

export const CustomInput = ({
  label,
  value,
  onChange,
  name,
  type,
  placeholder,
  error,
  instruction,
  inputStyle,
  containerStyle,
  inputRef,
  autoComplete = 'off',
  ariaControls = ''
}: {
  label: string,
  value: string,
  onChange: any,
  name: string,
  type: string,
  placeholder?: string,
  error: string | undefined,
  instruction?: string | undefined,
  inputStyle?: object,
  containerStyle?: object,
  inputRef?: React.RefObject<HTMLInputElement>
  autoComplete?: string,
  ariaAutocomplete?: 'none' | 'inline' | 'list' | 'both' | undefined;
  ariaControls?: string

}) => {
  const { t } = useTranslation()
  const [showPassword, setShowPassword] = useState(false)
  const inputId = `${name}-input`
  const errorId = `${name}-error`
  const instructionId = `${name}-instruction`
  const describedBy = [
    error ? errorId : '',
    instruction ? instructionId : ''
  ].filter(Boolean).join(' ')

  return (
    <div className='custom-input' style={{ ...containerStyle }}>
      <label htmlFor={inputId}>{label}</label>
      <div className='input-holder'>
      <input
          ref={inputRef}
          id={inputId}
          name={name}
          type={type === 'password' ? (showPassword ? 'text' : 'password') : type}
          value={value}
          placeholder={placeholder || ''}
          onChange={onChange}
          style={{ ...inputStyle }}
          aria-describedby={describedBy || undefined}
          autoComplete={autoComplete}
          aria-controls={ariaControls?.trim() ? ariaControls : undefined}
          aria-label={label}
        />
        {type === 'password' && (
          <button
            className='eye-icon-btn'
            type='button'
            onClick={() => setShowPassword(!showPassword)}
            aria-label={showPassword ? String(t('NAVBAR.HIDE_PASSWORD')) : String(t('NAVBAR.SHOW_PASSWORD'))}
          >
            {showPassword ? (
              <EyeSlashIcon aria-hidden="true" focusable="false" />
            ) : (
              <EyeIcon aria-hidden="true" focusable="false" />
            )}
          </button>

        )}
      </div>
      {error && <p className='error' id={errorId}>{error}</p>}
      {instruction && <p className='instruction' id={instructionId}>{instruction}</p>}
    </div>
  )
}
